import {Base} from "@/api/Base"

export class PayModeEdit extends Base {
    path = "payMode/edit"
}